import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  cardsList: {
    display: 'grid',
    width: '100%',
    padding: '20px 16px 20px 18px',
    gridGap: 16,
    gridTemplateColumns: 'repeat(auto-fill, [col-start] minmax(220px, 1fr) [col-end])'
  }
})

export default useStyles
